import { render, staticRenderFns } from "./OrderBulkActionModal.vue?vue&type=template&id=6abfb236&"
import script from "./OrderBulkActionModal.vue?vue&type=script&lang=ts&"
export * from "./OrderBulkActionModal.vue?vue&type=script&lang=ts&"
import style0 from "./OrderBulkActionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports